import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { FC } from 'react';

import {
  GenerateReportActions,
  InputSelect,
  InputSelectList,
  InputText,
  Loader,
} from '../../../../components';
import { orderByOptions } from '../../../../utils';
import {
  StyledFiltersContainer,
  StyledTableContainer,
} from '../../../../utils/styles';
import { InputSelectListOption, PaginationData } from '../../../../utils/types';
import { AltPlainDriverData } from '../../../../utils/types/driver';
import { TableData } from '../../types';
import { sortByOptions, transformData } from './utils';

type Props = {
  data: AltPlainDriverData[];
  isLoading: boolean;
  paginationData: PaginationData;
  onFilter: {
    firstName: (value: string) => void;
    document: (value: string) => void;
    transport: (value: InputSelectListOption | null) => void;
    sortBy: (value: string) => void;
    orderBy: (value: string) => void;
  };
  transportFilterQuery: (value: string) => void;
  transportFilterOptions: InputSelectListOption[];
  onGenerateReportPDF: () => void;
  onGenerateReportXLXS: () => void;
};

const TruckDriversReportsTable: FC<Props> = ({
  data,
  isLoading,
  paginationData,
  onFilter,
  transportFilterQuery,
  transportFilterOptions,
  onGenerateReportPDF,
  onGenerateReportXLXS,
}) => {
  const newData = transformData(data);

  const columns: ColumnsType<TableData> = [
    { title: 'Transporte', key: 'transport', dataIndex: 'transport' },
    { title: 'Permiso', key: 'license', dataIndex: 'license' },
    { title: 'Paut', key: 'paut', dataIndex: 'paut' },
    { title: 'Nombre', key: 'firstName', dataIndex: 'firstName' },
    { title: 'Apellido', key: 'lastName', dataIndex: 'lastName' },
    { title: 'Tipo y Nro. Doc', key: 'ic', dataIndex: 'ic' },
  ];

  // Filters
  const handleOnFilterFirstName = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilter.firstName(event.target.value);
    },
    [],
  );

  const handleOnFilterDocument = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilter.document(event.target.value);
    },
    [],
  );

  // Sorters
  const handleSortByOptionsSelect = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onFilter.sortBy(event.target.value);
    },
    [],
  );

  const handleOrderBySelect = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onFilter.orderBy(event.target.value);
    },
    [],
  );

  return (
    <StyledTableContainer>
      {isLoading && <Loader />}
      <StyledFiltersContainer>
        <InputText
          placeholder="Nombre"
          label="Nombre"
          onChange={handleOnFilterFirstName}
        />
        <InputText
          placeholder="Documento"
          label="Documento"
          onChange={handleOnFilterDocument}
        />
        <InputSelectList
          handleOnChange={onFilter.transport}
          handleOnInputChange={transportFilterQuery}
          options={transportFilterOptions}
          label="Transporte"
          placeholder="Transporte"
        />
      </StyledFiltersContainer>
      <StyledFiltersContainer>
        <InputSelect
          onChange={handleSortByOptionsSelect}
          options={sortByOptions}
          placeholder="Ordenar Por"
        />
        <InputSelect
          onChange={handleOrderBySelect}
          options={orderByOptions}
          placeholder="Ordenar Por"
        />
      </StyledFiltersContainer>
      <GenerateReportActions
        onGenerateReportPDF={onGenerateReportPDF}
        onGenerateReportXLXS={onGenerateReportXLXS}
      />
      <Table
        columns={columns}
        dataSource={newData}
        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: false,
          ...paginationData,
        }}
      />
    </StyledTableContainer>
  );
};

export default TruckDriversReportsTable;
